module.exports = __webpack_public_path__ + "images/for_companies_lp/logo_techcrunch_934df215a6f6888c4edac35b54fca2e5.jpg";